import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=04e6d1fe&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e6d1fe')) {
      api.createRecord('04e6d1fe', component.options)
    } else {
      api.reload('04e6d1fe', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=04e6d1fe&", function () {
      api.rerender('04e6d1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21y67tErl5yTr/JS/comp/FavElement.vue"
export default component.exports